var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.146,
    height: 43.185,
    viewBox: "0 0 43.146 43.185",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-icons",
    transform: "translate(1 1.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_campanha"
  }, /*#__PURE__*/React.createElement("g", {
    id: "megaphone-outline",
    transform: "translate(-3.375 -3.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4790",
    "data-name": "Path 4790",
    d: "M38.518,3.793s-8.57,10.66-16.61,10.66H6.083A1.583,1.583,0,0,0,4.5,16.035v9.5a1.583,1.583,0,0,0,1.583,1.583H21.908c8.041,0,16.61,10.7,16.61,10.7a1.444,1.444,0,0,0,2.38-.972V4.759a1.407,1.407,0,0,0-2.38-.968Z",
    transform: "translate(0.458)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4791",
    "data-name": "Path 4791",
    d: "M4.958,19.83s-1.583-.594-1.583-3.165S4.958,13.5,4.958,13.5",
    transform: "translate(0 4.118)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4792",
    "data-name": "Path 4792",
    d: "M31.5,18.555a2.287,2.287,0,0,0,0-4.352",
    transform: "translate(11.438 4.404)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4793",
    "data-name": "Path 4793",
    d: "M18,11.25V23.91",
    transform: "translate(5.948 3.203)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4794",
    "data-name": "Path 4794",
    d: "M7.875,11.25V23.91",
    transform: "translate(1.83 3.203)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4795",
    "data-name": "Path 4795",
    d: "M10.125,20.25V36.867a.792.792,0,0,0,.792.792H16.16a1.583,1.583,0,0,0,1.512-2.051c-.83-2.66-2.8-5.658-2.8-10.611h1.583a1.583,1.583,0,0,0,1.583-1.583V21.833a1.583,1.583,0,0,0-1.583-1.583H14.873",
    transform: "translate(2.745 6.863)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.48d904658d08aa73429658420d0aca6e.svg";
export { ForwardRef as ReactComponent };